import {Injectable} from '@angular/core';
import {MobicredApi} from '../../api/mobicred/mobicred.api.class';
import {Observable} from 'rxjs';
import {InitializeRequest} from 'src/app/interfaces/mobicred/InitializeRequest';
import {ValidateRequest} from 'src/app/interfaces/mobicred/ValidateRequest';

@Injectable({
  providedIn: 'root'
})
export class MobicredService {

  constructor(private mobicredApi: MobicredApi) { }

  initializeTransaction(sessionToken: string, username: string, password: string): Observable<any> {

    const initializeRequest: InitializeRequest = {
      username,
      password
    };

    return this.mobicredApi.initializeMobicredTransaction(sessionToken, initializeRequest);
  }

  requestOtp(sessionToken): Observable<any> {
    return this.mobicredApi.requestMobicredOtp(sessionToken);
  }

  validateTransaction(sessionToken: string, otp: number): Observable<any> {

    const validateRequest: ValidateRequest = {
      otp
    };

    return this.mobicredApi.validateMobicredTransaction(sessionToken, validateRequest);
  }

  retrieveMerchantConfig(sessionToken:string): Observable<any>{
    return this.mobicredApi.retrieveMerchantConfig(sessionToken);
  }
}
